/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 *
 * @return Formatted string.
 */
function humanFileSize(taille: number, dp = 1) {
  // Liste des préfixes de taille d'octets
  const prefixes: string[] = [
    "o",
    "Ko",
    "Mo",
    "Go",
    "To",
    "Po",
    "Eo",
    "Zo",
    "Yo",
  ];

  // Trouver l'index du préfixe approprié
  let i: number = 0;
  while (taille >= 1024 && i < prefixes.length - 1) {
    taille /= 1024;
    i++;
  }

  // Formater la taille avec le préfixe
  const tailleFormatee: string = `${taille.toFixed(dp)} ${prefixes[i]}`;

  return tailleFormatee;
}

export default humanFileSize;
